import { createContext, use, type ReactNode } from "react";

export interface AppConfig {
  /**
   * Public origin of the web app (no trailing slash), used to build shareable
   * links like group invites. On web this is `window.location.origin`; on
   * desktop the app runs from `file://`, so it injects the deployed web
   * origin for its stage instead.
   */
  webBaseUrl: string;
}

const AppConfigContext = createContext<AppConfig | null>(null);

export function AppConfigProvider({
  config,
  children,
}: {
  config: AppConfig;
  children: ReactNode;
}): ReactNode {
  return <AppConfigContext value={config}>{children}</AppConfigContext>;
}

export function useAppConfig(): AppConfig {
  const ctx = use(AppConfigContext);
  if (!ctx) {
    throw new Error("useAppConfig must be used inside <AppConfigProvider>");
  }
  return ctx;
}
